import React from "react";
import { ERCButton } from "components/button";
import { ERCText } from "components/text";
import styles from "./studentcardsm.module.scss";
import avatarImg from "assets/images/adebayobimpe.svg";
import { useNavigate } from "react-router-dom";
import durationIcon from "../../assets/images/durationIcon.svg";

const CourseCardSmall = ({
  img,
  text,
  description,
  title,
  duration,
  tutor,
}) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col  gap-2 bg-[#F2F2EE] px-6 pb-6  rounded-lg">
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="w-full rounded-md h-[179px] relative">
          <img src={img} alt="" className="w-full h-full object-contain" />
          <div className="absolute bg-primary text-secondary px-4 py-1 rounded-md bottom-10 left-2 z-10">
            <ERCText weight="700" size="12px">
              {text}
            </ERCText>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-6 justify-between">
          <div className="flex justify-between items-center w-full">
            <div className="flex items-center">
              <img src={durationIcon} alt="time-icon" />
              <ERCText size="12px" color="#252525">
                {duration}
              </ERCText>
            </div>
            <div className="flex items-center">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clip-path="url(#clip0_1243_1791)">
                    <path
                      d="M7.99967 11.5133L12.1197 13.9999L11.0263 9.31325L14.6663 6.15992L9.87301 5.75325L7.99967 1.33325L6.12634 5.75325L1.33301 6.15992L4.97301 9.31325L3.87967 13.9999L7.99967 11.5133Z"
                      fill="#FDCA15"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1243_1791">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <ERCText align="right" weight="700" size="12px">
                {"4.4(44)"}
              </ERCText>
            </div>
          </div>
          <div className={styles.description}>
            <ERCText size="20px" weight="700" color={"#0B7077"} lHeight="24px">
              {" "}
              {title ||
                "Worem ipsum amet, consec elit. dolor sit amet, consec elit."}{" "}
            </ERCText>
            <ERCText align="justify" size="14px" weight="400" lHeight="20px">
              {description ||
                "This specialized course is designed to support students with diverse learning needs, focusing on personalized teaching strategies and inclusive educational practices. The curriculum promotes self-confidence, communication skills, and cognitive development. "}
            </ERCText>
          </div>
        </div>

        <div className="flex justify-between items-center">
          <div className={styles.instructordetails}>
            <img src={avatarImg} alt="" />
            <ERCText size="12px" color="#525252">
              {tutor}
            </ERCText>
          </div>
          <div>
            <ERCButton
              height="38px"
              width="110px"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate("/login-student");
              }}
            >
              Enroll Now
            </ERCButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseCardSmall;
